"use client";

import { PropsWithChildren, useEffect, Suspense } from "react";
import { base64UrlEncode } from "../general";
import { TmaStartParams } from "./tmaStartParams";
import { clientConfig } from "@/lib/config/client-config";
import { useRouter, usePathname, useSearchParams } from "next/navigation";

export const TMA_PLATFORM = "tma";

function TmaRedirectLogic({ children }: PropsWithChildren) {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const platform = searchParams.get("platform");

    // Only redirect if platform=tma is present
    if (platform !== TMA_PLATFORM) {
      return;
    }

    try {
      // Extract parameters from URL
      const utm = searchParams.get("utm");
      const partner = searchParams.get("partner");

      // Prepare TMA start params
      const preparedParams: TmaStartParams = {};

      preparedParams.route = pathname;

      if (utm) {
        preparedParams.utm = utm;
      }

      if (partner) {
        preparedParams.partner = partner;
      }

      // Encode the parameters using UTF-8-safe, URL-safe base64url
      const encodedParams = base64UrlEncode(JSON.stringify(preparedParams));

      // Create redirect URL
      const redirectUrl = `${clientConfig.telegramBotLink}?startapp=${encodedParams}`;

      // Perform redirect
      window.location.href = redirectUrl;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Failed to redirect to TMA:", error);
    }
  }, [searchParams, pathname, router]);

  return <>{children}</>;
}

// Main provider component wrapped in Suspense
export function TmaRedirectProvider({ children }: PropsWithChildren) {
  return (
    <Suspense fallback={<>{children}</>}>
      <TmaRedirectLogic>{children}</TmaRedirectLogic>
    </Suspense>
  );
}
